import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-66de90a4")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "首页", -1)
const _hoisted_2 = { class: "tab-text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新农人圈 ")
const _hoisted_4 = {
  key: 0,
  class: "pop"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "收购记录", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "我的", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_tabbar, {
      modelValue: _ctx.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.active = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          to: "/",
          name: 0
        }, {
          icon: _withCtx(() => [
            (_ctx.active != 0)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 0,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/shouye-n.png"
                }))
              : _createCommentVNode("", true),
            (_ctx.active == 0)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 1,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/shouye-s-n.png"
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          to: "/farmerSpace",
          name: 1
        }, {
          icon: _withCtx(() => [
            (_ctx.active != 1)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 0,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/nongren-n.png"
                }))
              : _createCommentVNode("", true),
            (_ctx.active == 1)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 1,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/nongren-s-n.png"
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.notReadObj.count &&_ctx.notReadObj.count > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "+" + _toDisplayString(_ctx.notReadObj.count), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          to: "/purchaseRecord",
          name: 2
        }, {
          icon: _withCtx(() => [
            (_ctx.active != 2)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 0,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/shougou-n.png"
                }))
              : _createCommentVNode("", true),
            (_ctx.active == 2)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 1,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/shougou-s-n.png"
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          to: "/user",
          name: 3
        }, {
          icon: _withCtx(() => [
            (_ctx.active != 3)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 0,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/wode-n.png"
                }))
              : _createCommentVNode("", true),
            (_ctx.active == 3)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 1,
                  class: "icons-font",
                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/wode-s-n.png"
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}